export default __webpack_public_path__ + "static/media/aktuell_7.c345bf75.jpg";